import { IDS } from '../../adm-categorisation-action-id.constants';
import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import * as CapabilitiesActions from '../adm-cat-capabilities.actions';

class admCatCapabilitiesGridController extends GridController {
    constructor($ngRedux, $state, NavigationService, $filter) {
        super($ngRedux, $state, NavigationService);
        this.$ngRedux = $ngRedux;
        this.$filter = $filter;
        this.$state = $state;
    }

    $onInit() {
        this.filterOpen = true;
        this.filterExpandButtonVisible = false;
        this.filterTemplate = './adm-cat-capabilities-grid-filter.html';
        this.title = 'Site Capabilities';
        this.exportComponent = false;
        this.columns = [
            {title: '#', mapper: null},
            {title: 'Site Capability', mapper: 'name'},
            // {title: 'AHPRA Required', mapper: 'ahpra_licence_required'},
            // {title: 'Use license Required', mapper: 'use_licence_required'},
        ];
        this.unsubscribe = this.$ngRedux.connect(this.mapState().bind(this), CapabilitiesActions)(this);
        this.dataAction = this.fetchSiteCapabilitiesGrid;
        this.init();
    }



    $onDestroy() {
        this.destroy();


    }
}

admCatCapabilitiesGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter']

export const admCatCapabilitiesGrid = {
    bindings: {
        module: '<',
        identifier: '<',
        statePath: '<',
        // onRemove: '&',
        onSelect: '&',
    },
    controller: admCatCapabilitiesGridController,
    ...gridTpl
}
